import { Outlet, ScrollRestoration } from "react-router";

export function ScrollRestorationLayout() {
  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  );
}
